import { privacyPolicy } from '../data/content';
import usePageMeta from '../hooks/usePageMeta';

export default function Privacy() {
  usePageMeta({
    title: 'Norppa - Tietosuoja',
    description: 'Norppa-sovelluksen tietosuojakäytäntö. Lue miten käsittelemme tietojasi.',
    canonical: 'https://pulmakivi.fi/tietosuoja',
  });

  return (
    <div>
      <h1 className="page__title">Tietosuojakäytäntö</h1>
      <p className="legal-updated">Päivitetty: {privacyPolicy.lastUpdated}</p>

      {privacyPolicy.sections.map((section, i) => (
        <section key={i} className="legal-section">
          <h2>{section.title}</h2>
          <p>{section.content}</p>
          {section.links && (
            <ul className="legal-links">
              {section.links.map((link, j) => (
                <li key={j}>
                  <a href={link.url} target="_blank" rel="noopener noreferrer">
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          )}
          {section.contentAfterLinks && <p>{section.contentAfterLinks}</p>}
        </section>
      ))}
    </div>
  );
}
